const $ = jQuery

$.fn.extend({ wraplist: function() { return ajustaWrapper(); } });

const ajustaWrapper = () => {
  var offsetTop = $('.center-list').offset().top;
  var listHeight = $('.center-list').height();
  var windowHeight = $(window).height();
  
  if( listHeight <= windowHeight ) {
    $('.list-wrapper').css('height', windowHeight+'px');
  } else if( offsetTop > 0 ) {
    var totalHeight = (listHeight+offsetTop)+'px';
    $('.list-wrapper').css('height', totalHeight );
  }
}

const handlerOrderFilter = () => {
  const that = event.target
  var result;
  $(that).parents('ul').find('.checkbox').removeClass('checked');
  $(that).addClass('checked');
  
  if( $(that).hasClass('asc') ) {
    $('.gallery-img').cycle('destroy');
    result = $('ul.list > .item').sort(asc_sort);
    $('ul.list').empty();
    result.appendTo('ul.list');
    doCycle();
  } else if( $(that).hasClass('desc') ) {
    $('.gallery-img').cycle('destroy');
    result = $('ul.list > .item').sort(dec_sort);
    $('ul.list').empty();
    result.appendTo('ul.list');
    doCycle();
  } else {
    $('.gallery-img').cycle('destroy');
    result = $('ul.list > .item').sort(cron_sort);
    $('ul.list').empty();
    result.appendTo('ul.list');
    doCycle();
  }
}

// accending sort
// http://stackoverflow.com/a/8838790/1001109
const asc_sort = (a, b) => {
  return ($(b).find('.header').text()) < ($(a).find('.header').text()) ? 1 : -1;
}

// decending sort
const dec_sort = (a, b) => {
  return ($(b).find('.header').text()) > ($(a).find('.header').text()) ? 1 : -1;
}

// chrono sort
const cron_sort = (a, b) => {
  return ($(b).find('.time.hidden').text()) < ($(a).find('.time.hidden').text()) ? 1 : -1;
}

const doCycle = () => {
  $.each( $('.list .item'), function(i,v) {
    cl = $(this).attr('class').replace( /item/, '' ).trim();
    if( $(this).find('.gallery-img img').length > 0 ) {
      $(this).find('.gallery-img').cycle({
        pager: '.'+cl+' .gallery-nav'
      }).cycle('pause');
    }
  }).wraplist();
}

( () => {
  $('.order .checkbox').on('click', handlerOrderFilter)
})()